<template>
   <el-row class="alltext">
      <div v-if="liad_show">
           <load></load>
         </div>
     <div class="first_div">
       <div class="first_con">
         <div class="fir_fen con" @click="nav_status.logo_dialog=true" >
           <!-- <el-avatar :size="100" :src="info.logo"></el-avatar> -->
           <el-avatar :size="100" fit="scale-down "  style="margin-top: 10px;">
            <img :src="info.logo"  style="width: 100%;"/>
           </el-avatar>
         </div>
          <div class="fir_fen conss">
           <p> 编号：{{info.num}}</p>
            <p>名称：{{info.name}}</p>
          </div>
          <div class="fir_fen con">
              <el-button type="primary" @click="nav_status.form_dialong=true">立即修改</el-button>
          </div>
       </div>
       <div class="first_right">
         <div class="qyxxhead">
             <div class="qyxxheadleft">
                 <img src="" alt="">
             <div class="qyxxheadtext"><h3>系统设置</h3> </div>
             </div></div>
             <!--内容-->
             <!--视频播放设置-->
             <div class="Pbsettings">
                 <div class="nametext">视频播放设置:</div>
                 <div class="nametext" style="padding: 0 2rem;">进度条控制:</div>
                 <div class="">
                   <el-switch
                     v-model="info_sys.video_percentage"
                     @change="save_system('video_percentage')"
                     active-color="#13ce66"
                     inactive-color="#ff4949">
                   </el-switch>
                 </div>
                 <div class="nametext" style="padding: 0 2rem;">倍数控制:</div>
                 <div class="">
                   <el-switch
                     v-model="info_sys.video_multiple"
                     @change="save_system('video_multiple')"
                     active-color="#13ce66"
                     inactive-color="#ff4949">
                   </el-switch>
                 </div>
             </div>
             <!--考核次数设置-->
             <div class="Pbsettings">
                 <div class="nametext">考核次数设置:</div>
                 <el-select v-model="info_sys.exam_num" placeholder="请选择" style="padding: 0 2rem;" @change="save_system('exam_num')">
                     <el-option
                       v-for="item in exam_num"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
                     </el-option>
                   </el-select>
             </div>
             <div class="Pbsettings">
               <div class="nametext">试卷详情:</div>
               <div style="padding:0 0 0 2rem">
                 <el-switch
                   v-model="info_sys.exam_watch"
                   @change="save_system('exam_watch')"
                   active-color="#13ce66"
                   inactive-color="#ff4949">
                 </el-switch>
               </div>
               <div class="nametext">(开启后：在任务截止日期前，无法查看试卷答案及解析)</div>
             </div>
             <!--密码策略（强制性）-->
             <div class="Pbsettings">
                 <div class="nametext">密码策略（强制性）:</div>
                 <el-select v-model="info_sys.pwd_time" placeholder="请选择" style="padding: 0 2rem;" @change="save_system('pwd_time')">
                     <el-option
                       v-for="item in pwd_time"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
                     </el-option>
                   </el-select>
             </div>
       </div>
     </div>
     <div class="tow_div">
       <div class="tow_con">
         <div class="tow_cc con">
           <el-avatar  shape="square" style="background-color: white;" :size="50" :src="require('../../../assets/enter_per.png')"></el-avatar>
         </div>
         <div class="tow_cc cons">
           <p>{{info.used}}</p>
           <p>员工</p>
         </div>
       </div>
       <div class="tow_con"><div class="tow_cc con">
           <el-avatar  shape="square" style="background-color: white;" :size="50" :src="require('../../../assets/enter_video.png')"></el-avatar>
         </div>
         <div class="tow_cc cons">
           <p>{{info.video.public}}</p>
           <p>公共视频</p>
         </div></div>
       <div class="tow_con"><div class="tow_cc con">
           <el-avatar  shape="square" style="background-color: white;" :size="50" :src="require('../../../assets/enter_video.png')"></el-avatar>
         </div>
         <div class="tow_cc cons">
           <p>{{info.video.local}}</p>
           <p>内部视频</p>
         </div></div>
     </div>
     <div class="tow_div">
       <div class="tow_con">
         <div class="tow_cc con">
           <el-avatar  shape="square" style="background-color: white;" :size="50" :src="require('../../../assets/enter_storage.png')"></el-avatar>
         </div>
         <div class="tow_cc cons">
           <p>{{info.space.used}}G</p>
           <p>空间</p>
         </div>
       </div>
       <div class="tow_con"><div class="tow_cc con">
           <el-avatar  shape="square" style="background-color: white;" :size="50" :src="require('../../../assets/enter_slogan.png')"></el-avatar>
         </div>
         <div class="tow_cc cons">
           <p>{{info.slogan}}</p>
           <p>slogan</p>
         </div></div>
       <div class="tow_con"><div class="tow_cc con">
           <el-avatar  shape="square" :size="50" style="background-color: white;" :src="require('../../../assets/enter_time.png')"></el-avatar>
         </div>
         <div class="tow_cc cons">
           <p>{{info.time}}</p>
           <p>到期时间</p>
         </div></div>
     </div>




     <el-dialog title="编辑企业信息" :visible.sync="nav_status.form_dialong">
       <el-form>
         <el-form-item label="企业名称" >
           <el-input v-model="form.name"></el-input>
         </el-form-item>
            <el-form-item label="slogan" >
           <el-input v-model="form.slogan"></el-input>
         </el-form-item>
       </el-form>
       <div slot="footer" class="dialog-footer">
         <el-button @click="nav_status.form_dialong = false">取 消</el-button>
         <el-button type="primary" @click="info_save()">确 定</el-button>
       </div>
     </el-dialog>


         <el-dialog :visible.sync="nav_status.logo_dialog">
           <el-upload
             class="upload-demo"
             accept=".jpg, .jpeg, .png"
             ref="upload"
             action=""
             :http-request="logo_save"
             :on-exceed="logo_check"
             :file-list="fileList"
             :limit="1"
             :auto-upload="false">
             <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
             <el-button style="margin-left: 10px;" size="small" type="success" @click="logo_submit()">上传到服务器</el-button>
             <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
           </el-upload>
         </el-dialog>

   </el-row>
</template>
<script>
  import load from '../../../components/load.vue';
export default {
    data(){
      return{
        liad_show:'',
        info_sys:{},
        exam_num: [{
          value: '1',
          label: '1'
        }, {
          value: '2',
          label: '2'
        }, {
          value: '3',
          label: '3'
        }, {
          value: '4',
          label: '4'
        }, {
          value: '5',
          label: '5'
        },{
          value: '999',
          label: '不限'
        }],
        pwd_time:[{
          value: '0',
          label: '关闭'
        }, {
          value: '3',
          label: '每三个月修改一次'
        }, {
          value: '6',
          label: '每六个月修改一次'
        }, {
          value: '12',
          label: '每一年修改一次'
        }],

        fileList: [],
        info:{},
        nav_status:{
          form_dialong:false,
          logo_dialog:false
        },
        formLabelWidth: '120px',
        form: {
          name:'',
          slogan:''
        },
      }
    },
    components: {
      load:load
    },
    mounted() {
      this.get_info()
    },
    methods:{
      get_system(){
        let _this=this
        _this.axios.get('/v2/c_company/get_system').then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.info_sys=res.data.data
               _this.liad_show=false
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      save_system(val){
        let _this=this
        var data={
          'type':val,
          'value':_this.info_sys[val]
        }
        _this.axios.post('/v2/c_company/save_system',{data:data}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.$message.success(res.data.msg)
            }else{
              _this.$message.error(res.data.msg)
              _this.info_sys[val]=res.data.data.value
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      get_info(){
        let _this=this
        _this.liad_show=true
        _this.axios.get('/v2/c_company/get_info').then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.info=res.data.data
              _this.form.name=res.data.data.name
              _this.form.slogan=res.data.data.slogan
              _this.get_system()
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },

      handleRemove(file, fileList) {

      },
      handlePreview(file) {

      },

      logo_submit(){
        this.$refs.upload.submit()
      },

      logo_save(file){
        let _this=this
        var data = new FormData();
        data.append("file", file.file);
        _this.axios.post('/v2/c_company/update_logo',data,{ headers: { "Content-Type": "multipart/form-data" } }).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.$message.success(res.data.msg)
              _this.nav_status.logo_dialog=false
              _this.get_info()
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },

      logo_check(){
        this.$message.error('请先删除列表中的图片文件')
      },

      info_save(){
        let _this=this
        _this.axios.post('/v2/c_company/update_info',{data:_this.form}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.$message.success(res.data.msg)
              _this.nav_status.form_dialong=false
              _this.get_info()
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      }
    },


    }

</script>
<style scoped>
  .tow_cc{
    flex: 1;
  }
 .tow_div{
   display: flex;
   height: 250px;
   margin-top: 20px;
 }
 .tow_con{
   flex: 1;
   background-color: white;
   margin-left: 30px;
   display: flex;
 }
  .first_right{
    flex: 1;
    margin-left: 20px;
    background-color: white;
  }
.alltext{
  width: 100%;
  height: 100%;
  background-color: #f6f8ff;
}
.first_div{
  display: flex;
   height: 300px;
   margin-top: 20px;
  }
  .first_con{
    flex: 1;
    margin-left: 20px;
    display: flex;
    background-color: white;
  }
  .fir_fen{
    flex: 1;
    height: 100%;
  }
  .con{
    display: flex;
    align-items: center; /*定义body的元素垂直居中*/
    justify-content: center; /*定义body的里的元素水平居中*/
  }
  .cons{
	position: relative;
	top: 40%; /*偏移*/
	left: 0;
  }
  .conss{
    position: relative; /*脱离文档流*/
                      top: 40%; /*偏移*/
                      left: 0;
  }
 .qyxxhead{
     width: 100%;
     height: 60px;
     margin-top: 10px;

 }
 .qyxxheadtext{
     margin-left: 10px;
 }

 .qyxxheadleft{
   float: left;
   display: flex;
   align-items: center;
   height: 100%;

 }
 .nametext{
    color:#696969;
 }
 .Pbsettings{
     border-top: 1px solid rgb(199, 192, 192);
     height: 60px;
     display: flex;
     align-items: center;
    padding-left: 20px;
 }
</style>



// WEBPACK FOOTER //
// src/view/company/System/Enterprise.vue